var roomImageGridTemplate = require('templates/roomImageGrid.hbs');
var AriesComponent = require('libs/aries-component');
var FadeInHandler = require('libs/fade-in-handler');
var carouselWidthHandler = require('libs/multiCarousel-width-handler');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'roomImageGrid',
  template: {
    'roomImageGrid': roomImageGridTemplate
  },
  bindEvents: function($) {
    var _self = this,
      $carousel,
      viewGalleryPopup,
      mediaDesktop = window.matchMedia("(min-width: 769px)"), $slides, $gallery, $galleryWrapper, $popup;
    _self.parentSelector = $('[data-component-id="' + _self.componentId + '"]'),
     $carousel = _self.parentSelector.find('.l-tiers-carousel.mi-carousel'),
     $popup = _self.parentSelector.find('.l-room-image-grid-popup');
     _self.$gallery = _self.parentSelector.find('#view-gallery-popup .mi-carousel');
     _self.$galleryWrapper = _self.parentSelector.find('#view-gallery-popup .article-content');
     $visableImages = $carousel.find('.l-carousel-wrapper:not(.l-display-none)');
    $carousel.on('init', function(event, slick) {
      $('#view-gallery-popup .view-gallery-carousel').slick();
      _self.$el.find('.l-tiers-carousel.mi-carousel .l-picture-wrapper img').first().on('load', function() {
        setTimeout(function() {
          carouselWidthHandler.calculateWidth.call(_self);
          _self.$el.find('.l-view-gallery-wrapper').removeAttr('aria-hidden');
          if (mediaDesktop.matches) {
            $carousel.find('[aria-describedby]').removeAttr('aria-describedby');
            $carousel.find('.l-view-gallery-wrapper a').attr('tabindex', 0);
          }
        }, 0);
      });
    });

    viewGalleryPopup = new Popup({
      items: {
        src: '#view-gallery-popup',
        type: 'inline'
      },
      selector: '.tile-room-image-grid .js-popup',
      alternateCloseMarkup: true,
      fullScreen: true,
      mainClass: 'mi-gallery mi-gallery-full',
      preventGlobalReinit: true
    });

    viewGalleryPopup.register();
    _self.$modalSelector = _self.$el.find('.js-popup');
    _self.$modalSelector.on('mfpOpen', function() {
      $("#view-gallery-popup").closest('.mfp-content')
        .addClass("l-margin-none l-max-width-max l-width-max")
        .css("height", "100%"); 
        _self.handleScreenOrientation();
        var startingPoint = 0;
        if($visableImages.length > 0)
          _self.$gallery.slick('slickGoTo', $visableImages.length);
    });
    
    _self.screenSizeMediaQuery = window.matchMedia("(orientation: portrait)");
    _self.screenSizeMediaQuery.addListener(_self.handleScreenOrientation.bind(_self));

  },
  handleScreenOrientation: function() {
   var _self = this,
     $slides = _self.$gallery.find('.slider-slide');
	    $slides.height(_self.$galleryWrapper.width() * 0.5625 + 'px');
	    $slides.css({
	      'maxHeight': ($(window).height() - _self.$galleryWrapper.find('.mi-gallery-header').outerHeight()) + 'px'
      });
  }
});
